<div class="m-rich-text" v-html="value"></div>
